export default {
  props: {
    selectedRows: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:selectedRows'],
  data() {
    return {
      SelectedRowsLocal: new Set(this.selectedRows.map(row => row.id)), // Sync initial selection
    };
  },
  watch: {
    // Sync local selection with the prop when the parent updates it
    selectedRows(newVal) {
      this.SelectedRowsLocal = new Set(newVal.map(row => row.id));
    },
  },
  methods: {
    /**
     * Toggles row selection (selects if not selected, deselects if selected)
     */
    toggleRowSelection(row, key = "id") {
      const rowId = row[key];
      if (this.SelectedRowsLocal.has(rowId)) {
        this.SelectedRowsLocal.delete(rowId);
      } else {
        this.SelectedRowsLocal.add(rowId);
      }
      this.emitSelection();
    },

    /**
     * Checks if a row is selected
     */
    isRowSelected(row, key = "id") {
      return this.SelectedRowsLocal.has(row[key]);
    },

    /**
     * Selects all rows
     */
    selectAll(rows, key = "id") {
      this.SelectedRowsLocal = new Set(rows.map(row => row[key]));
      this.emitSelection();
    },

    /**
     * Clears all selected rows
     */
    clearSelection() {
      this.SelectedRowsLocal.clear();
      this.emitSelection();
    },

    /**
     * Emits selected rows to the parent
     */
    emitSelection() {
      const selectedArray = Array.from(this.SelectedRowsLocal);
      this.$emit("update:selectedRows", selectedArray);
    },
  },
};
